import store from '@/store';
import { CBR } from '@/utils/ppm/permissions';

const createPermissionChecker = permissionId => () => store.getters['cbr/hasPermission'](permissionId);

export default [
    {
        routeName: 'cbr.unittypes',
        items: [
            {
                title: 'add new unit type',
                routeName: 'cbr.unittypes.create',
                params: {},
                allowed: createPermissionChecker(CBR.UNIT_TYPES_CREATE),
            },
        ],
    },
    {
        routeName: 'cbr.unittypes.details',
        items: [],
    },
];
